import { Box, Card, styled, Button } from "@mui/material";
import FlexBetween from "components/flexbox/FlexBetween";
import FlexBox from "components/flexbox/FlexBox";
import SearchInput from "components/input-fields/SearchInput";
import { useEffect, useState, useCallback } from "react";
import FieldVisitTable from "page-sections/FieldVisit/FieldVisitTable";
import apiService from "Network/apiService";
import { API_ENDPOINTS } from "Network/apiEndpoints";
import { usePageTitle } from "contexts/PageTitleContext";
import { Add, GetApp } from "@mui/icons-material";
import FieldVisitExportModal from "page-sections/FieldVisit/FieldVisitExportModal";
import CropHubTable from "page-sections/CropHub/CropHubTable";
import CropHubAddUpdate from "page-sections/CropHub/CropHubAddUpdate";

const CropHub = () => {
    const { setPageTitle } = usePageTitle();
    const [fieldVisits, setFieldVisits] = useState([]);
    const [searchValue, setSearchValue] = useState("");
    const [loading, setLoading] = useState(false);
    const [exportModalOpen, setExportModalOpen] = useState(false);
const [refreshKey, setRefreshKey] = useState(0);
  const handleRefresh = () => {
    setRefreshKey((prev) => prev + 1); // increments to force re-fetch
  };

    useEffect(() => {
        setPageTitle('Crop Hub');
    }, [setPageTitle]);

    const fetchFieldVisits = useCallback(async () => {
        setLoading(true);
        try {
            const response = await apiService.get(API_ENDPOINTS.GET_field_visit);

            if (response?.success && response?.data?.FieldVisit) {
                setFieldVisits(response.data.FieldVisit);
            } else {
                setFieldVisits([]);
            }
        } catch (error) {
            console.error("API error:", error);
            setFieldVisits([]);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchFieldVisits();
    }, [fetchFieldVisits]);

    // Export handlers
    const handleExportClick = () => {
        setExportModalOpen(true);
    };

    const handleExportModalClose = () => {
        setExportModalOpen(false);
    };

    return (
        <Box pt={2} pb={4}>
            <FlexBetween flexWrap="wrap" mb={2}>
                <FlexBox alignItems="center" gap={2} style={{ flexGrow: 1 }}>
                    <SearchInput
                        bordered={false}
                        placeholder="Search by Crop Name, Scientific Name, Countries"
                        onChange={e => setSearchValue(e.target.value)}
                        value={searchValue}
                        sx={{
                        width: "45%",
                        maxWidth: "none !important"
                    }}
                                        />
                </FlexBox>
                <Box>
                    <Button
                        variant="contained"
                        size="small"
                        startIcon={<Add />}
                        onClick={handleExportClick}
                        sx={{ textTransform: 'none' }}
                    >
                        ADD Crop
                    </Button>
                </Box>
            </FlexBetween>

            <Card>
                <Box sx={{ mt: 1 }}>
                    <CropHubTable
                    key={refreshKey} 
                        fieldVisits={fieldVisits}
                        searchQuery={searchValue}
                        loading={loading}
                        // onRefresh={handleRefresh}
                    />
                </Box>
            </Card>

            <CropHubAddUpdate  
                open={exportModalOpen}
                onClose={handleExportModalClose}
                 onRefresh={handleRefresh} 
            />
        </Box>
    );
};

export default CropHub;

